<template>
<el-form ref="form" :model="dept" label-width="120px">
    <el-row :xs="24" sm="12">
        <el-col :xs="24" :sm="18">
            <el-form-item :label="msg('面单服务商')">
                <el-input v-model="dept.pageSender" placeholder="请输入面单服务商"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18">
            <el-form-item :label="msg('黑猫寄件人')">
                <el-input v-model="dept.pageHmSender" placeholder="请输入面单服务商"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18">
            <el-form-item :label="msg('Line')">
                <el-input v-model="dept.pageLine" placeholder="请输入Line,如：@yip3025t"></el-input>
            </el-form-item>
        </el-col>
    </el-row>
    
    <div style="text-align:center;margin-top: 15px;">
        <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
        <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
    </div>

</el-form> 
</template>

<script>
export default {
  name: 'ProductEdit',
  data(){
    return{
    }
  }, 
  computed:{
    imageUrl:{
          get(){
              if(this.dept.logo){
                  return this.$kit.api.imgView+this.dept.logo;
              }
              return null;
          }
      }
  },
  props:{
        id:Number,
        dept: Object,
  },
  mounted: function(){
  },
  methods:{
    init(){},
    onSubmit(){
        if(!this.id){
            this.$message(this.msg('请选中数据后再进行操作'));
            return;
        }
        let param = {
            id:this.id,
            pageSender:this.dept.pageSender,
            pageHmSender:this.dept.pageHmSender,
            pageLine:this.dept.pageLine,
        }
        this.$axios.post(this.$kit.api.dept.updatePageSender,param)
            .then((result) => {
                    if(result.status){
                        this.$emit("close-dg", true);
                    }
                    this.$message(result.msg);
                });
    },
  }
}
</script>


<style scoped lang="scss">
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 64px;
        height: 64px;
        line-height: 64px;
        text-align: center;
    }
    .avatar {
        width: 64px;
        height: 64px;
        display: block;
    }

.w-e-toolbar{flex-wrap: wrap;}
.icon-list{ margin:0px; padding:0px; display:flex; flex-wrap:wrap;  border: 1px solid #eaeefb;}
.icon-list li{cursor:pointer;
    padding:8px; border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    display:flex; flex-direction: column; justify-content: center; align-items:center;
}
.icon-list li i{font-size:18px;} 
.icon-list li:hover{color:#5CB6FF;}
.upload-icon .el-form-item__content{display:flex;}
.upload-icon .el-form-item__content >*:last-child{margin-left:10px;}
</style>
